/**
 * Page-size scale for the products list. Kept out of `products-list-view.tsx` so
 * that file only exports components — mixing constants in breaks fast refresh
 * (`react-refresh/only-export-components`).
 */

/** Page sizes offered in both view modes. Capped at 100 — beyond that a single
 *  page is slower to fetch than it is useful to scan. */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/** Shared default. Grid and table use the same value so switching view doesn't
 *  silently change how much you're looking at, and so the size selector always
 *  has a matching option — a value outside `PAGE_SIZE_OPTIONS` renders it blank,
 *  which is what a grid default of 9 used to do. */
export const DEFAULT_PAGE_SIZE = 10;
